import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ListArchivedCompaniesParams } from 'src/app/core/companies.service';
import { UtilsService } from 'src/app/core/utils.service';
import { COMPANY_ID_LABEL, BUSINESS_NAME_LABEL, VAT_LABEL } from 'src/app/shared/constants/translations';

@Component({
  selector: 'app-archived-companies-filters',
  templateUrl: './archived-companies-filters.component.html',
  styleUrls: ['./archived-companies-filters.component.scss'],
})
export class ArchivedCompaniesFiltersComponent {
  @Input() filters?: ListArchivedCompaniesParams;
  @Output() filter_clear: EventEmitter<ListArchivedCompaniesParams> = new EventEmitter<ListArchivedCompaniesParams>();

  constructor(private utils_service: UtilsService) {}

  onFilterClear(key: string): void {
    if (this.filters) {
      this.filters[key as keyof typeof this.filters] = undefined;
      this.filter_clear.emit(this.filters);
    }
  }

  getFiltersKeys(): string[] {
    if (this.filters) {
      return Object.keys(this.filters).filter(k => {
        if (!this.filters) return false;
        return this.filters[k as keyof typeof this.filters] != null;
      });
    }
    return [];
  }

  getLabelByKey(key: string): string {
    const available_keys: string[] = Object.keys(this.filters || []);
    console.log(key);
    console.log(available_keys);
    switch (key) {
      case available_keys[0]:
        return COMPANY_ID_LABEL;
      case available_keys[1]:
        return BUSINESS_NAME_LABEL;
      case available_keys[2]:
        return VAT_LABEL;
      default:
        return '';
    }
  }

  getContentByKey(key: string): string {
    const available_keys: string[] = Object.keys(this.filters || []);
    switch (key) {
      case available_keys[0]:
        return this.filters?.company_id || '-';
      case available_keys[1]:
        return this.filters?.business_name || '-';
      case available_keys[2]:
        return this.filters?.vat || '-';
      default:
        return '';
    }
  }
}
